// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1o4PE","question":"Question_question__39FoP","description":"Question_description__1fzdD"};